import { APP_PDC_URL } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const previewConstants = {
  GET_PREVIEW_DEADLINE_START: "GET_PREVIEW_DEADLINE_START",
  GET_PREVIEW_DEADLINE_SUCCESS: "GET_PREVIEW_DEADLINE_SUCCESS",
  GET_PREVIEW_DEADLINE_ERROR: "GET_PREVIEW_DEADLINE_ERROR"
};

export function loadPreview(
  clientIdSelected,
  idAttachment,
  page
) {
  return function(dispatch, getState) {

    const auth = getState().auth;
    const main = getState().main;
    const accountantIdSelected = main?.accountantIdSelected;

    let request = {
      method: "get",
      url:
        APP_PDC_URL +
        `/v2/documents/${idAttachment}/preview/${page ||
        1}?itemId=${clientIdSelected}&accountantId=${accountantIdSelected}`,
      headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: previewConstants.GET_PREVIEW_DEADLINE_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(res => {
          if (res.status === 200) {
            let requestFilename = {
              method: "get",
              url:
                APP_PDC_URL +
                `/v2/documents/${idAttachment}?itemId=${clientIdSelected}&accountantId=${accountantIdSelected}`,
              headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
            };
            const contentAttachment = res.data.content;
            callWithRetry(
              auth, requestFilename, dispatch
            )
              .then(resFilename => {
                dispatch({
                  type: previewConstants.GET_PREVIEW_DEADLINE_SUCCESS,
                  payload: {
                    content: contentAttachment,
                    idAttachment: idAttachment,
                    fileName: resFilename.data.filename
                  }
                });
                resolve(res.data);
              })
              .catch(() => {
                resolve(res.data);
              });
          } else {
            dispatch({
              type: previewConstants.GET_PREVIEW_DEADLINE_ERROR,
              error: res
            });
            reject();
          }
        })
        .catch(response => {
          dispatch({
            type: previewConstants.GET_PREVIEW_DEADLINE_ERROR,
            error: response.toString()
          });
          reject();
        });
    });
  };
}
